let csrfRefreshPromise = null;

export function refreshCsrfCookieOnce(refresher) {
    if (csrfRefreshPromise === null) {
        csrfRefreshPromise = Promise.resolve()
            .then(() => refresher())
            .finally(() => {
                csrfRefreshPromise = null;
            });
    }

    return csrfRefreshPromise;
}

export function retryAfterCsrfRefresh(error, refresher, requester) {
    if (!error?.config || error.config.__csrfRetried) {
        return Promise.reject(error);
    }

    const headers = { ...error.config.headers };
    delete headers["X-XSRF-TOKEN"];
    delete headers["x-xsrf-token"];

    const retryConfig = { ...error.config, headers, __csrfRetried: true };

    return refreshCsrfCookieOnce(refresher).then(() => requester(retryConfig));
}
